import cn from 'classnames';
import { Fragment } from 'react';

const PortalCurrencyIcon = ({
    show,
    className,
    disabled
}: {
    show?: string;
    className?: string;
    disabled?: boolean;
}) => {
    return (
        <Fragment>
            {show ? (
                <div
                    title={show}
                    className={cn(
                        'w-3.5 h-3.5 lg:h-4 lg:w-4 rounded-full overflow-clip',
                        {
                            ['opacity-80']: disabled
                        },
                        className
                    )}>
                    <img src={`/currency_icons/svg/color/${show.toLowerCase()}.svg`} alt={show} />
                </div>
            ) : (
                <div
                    title={show}
                    className={cn('w-3.5 h-3.5 lg:h-4 lg:w-4 bg-brand-neutral-500 rounded-full', className)}
                />
            )}
        </Fragment>
    );
};

export default PortalCurrencyIcon;
